import React, { useEffect, useState } from "react";
import Dropdown from "../DropDown";
import apiClient from "../../../services/apiClient";
import { getHeaders } from "../../ApiHeaders/apiHeaders";
import { datadogRum } from "@datadog/browser-rum";

interface DateRangeDropdownProps {
  selectedValue: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
  refreshCounter?: number;
}

const DateRangeDropdown: React.FC<DateRangeDropdownProps> = ({
  selectedValue,
  onChange,
  disabled = false,
  refreshCounter,
  className = "w-full p-1 sm:p-1 pl-4 pr-16 border border-gray-300 rounded-lg bg-[#f6f6f6] text-[#000000] shadow-inner text-xs md:text-base appearance-none",
}) => {
  const [options, setOptions] = useState<{ label: string; value: string }[]>(
    []
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDateRanges = async () => {
      try {
        const cachedData = sessionStorage.getItem("dateRanges");
        if (cachedData) {
          setOptions(JSON.parse(cachedData));
          return;
        }

        const headers = await getHeaders();
        datadogRum.addAction("Fetching Date Ranges", {
          url: "/ref-data/timeranges",
        });
        const response = await apiClient.get("/ref-data/timeranges", {
          headers,
        });

        if (response.data?.response?.data) {
          const apiData = response.data.response.data;

          const formattedData = Object.entries(apiData).map(
            ([label, value]) => ({
              label,
              value: String(value),
            })
          );

          const fullData = [
            ...formattedData,
            { label: "Custom", value: "custom" },
          ];
          setOptions(fullData);
          sessionStorage.setItem("dateRanges", JSON.stringify(fullData));
        }
      } catch (error) {
        console.error("Error fetching Date Ranges:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDateRanges();
  }, []);

  return (
    <Dropdown
      options={options}
      selectedValue={selectedValue}
      onValueChange={onChange}
      disabled={disabled || loading}
      className={className}
      placeholder="Select Date Range"
    />
  );
};

export default DateRangeDropdown;
